








































































import {Component, Vue, Mixins, Prop} from "vue-property-decorator";
import Loading from "@/mixins/loading";
// api
import {chargeDataBoard} from "@/api/recharge";


@Component
export default class DataBoard extends Mixins(Loading) {
  title1:String="今日储蓄金额（元）";
  data1:String="0";
  LeftTitle1:String="养生元（元）"
  leftData1:Number=0;
    rightTitle1:String="赠送金（元）"
    rightData1:Number=0;

    title2:String="今日储蓄笔数（笔）";
    data2:String="0";
    LeftTitle2:String="首次（笔）"
    leftData2:Number=0;
    rightTitle2:String="复充（笔）"
    rightData2:Number=0;

    title3:String="今日首次客户数量/金额（人/元）";
    data3:String="0";
    LeftTitle3:String="养生元（元）"
    leftData3:String="0";
    rightTitle3:String="赠送金（元）"
    rightData3:String="0";

    title4:String="今日复充客户数量/金额（人/元）";
    data4:String="0";
    LeftTitle4:String="养生元（元）"
    leftData4:Number=0;
    rightTitle4:String="赠送金（元）"
    rightData4:Number=0;

    mounted() {
        this.getData(1);

    }
    showBoard(tag:String){
       let tagType:number=1;
        if(tag == "today"){
            tagType=1;
            this.getData(tagType);
        }else if(tag=="month"){
            tagType=2;
            this.getData(tagType);
        }else {
            tagType=3;
            this.getData(tagType);
        }
      let tags=  document.querySelectorAll("#charge_tags div");
        tags.forEach(function (item,index){
            item.className = "tag";
        });
        tags[tagType-1].className="tag-select";

    }


    getData(tagType: number) {
        chargeDataBoard(tagType).then((res) => {
            if(tagType==1){
                this.title1="今日储蓄金额（元）";
                this.data1 = res.data.chargeAmount||0;
                this.LeftTitle1= "养生元（元）"
                this.leftData1=res.data.balanceAmount||0;
                this.rightTitle1= "赠送金（元）"
                this.rightData1=res.data.giveAmount||0;

                this.title2="今日储蓄笔数（笔）";
                this.data2 = res.data.totalCount;

                this.LeftTitle2= "首次（笔）"
                this.leftData2 = res.data.firstCount;
                this.rightTitle2= "复充（笔）"
                this.rightData2 = res.data.repeatedCount;



                this.title3="今日首次客户数量/金额（人/元）";
                this.data3 = res.data.firstNumberPeople+"/"+res.data.firstAmount;

                this.LeftTitle3= "养生元（元）"
                this.leftData3 = res.data.firstBalanceAmount||0;
                this.rightTitle3= "赠送金（元）"
                this.rightData3 = res.data.firstGiveAmount||0;

                this.title4="今日复充客户数量/金额（人/元）";
                this.data4 = res.data.repeatedNumberPeople+"/"+res.data.repeatedAmount;
                this.LeftTitle4= "养生元（元）"
                this.leftData4 =res.data.repeatedBalanceAmount||0;
                this.rightTitle4= "赠送金（元）"
                this.rightData4 =res.data.repeatedGiveAmount||0;

            }else if(tagType==2){
                this.title1="本月储蓄金额（元）";
                this.data1 = res.data.chargeAmount;
                this.LeftTitle1= "养生元（元）"
                this.leftData1=res.data.balanceAmount||0;
                this.rightTitle1= "赠送金（元）"
                this.rightData1=res.data.giveAmount||0;

                this.title2="本月储蓄笔数（笔）";
                this.data2 = res.data.totalCount;

                this.LeftTitle2= "首次（笔）"
                this.leftData2 = res.data.firstCount;
                this.rightTitle2= "复充（笔）"
                this.rightData2 = res.data.repeatedCount;



                this.title3="本月首次客户数量/金额（人/元）";
                this.data3 = res.data.firstNumberPeople+"/"+res.data.firstAmount;

                this.LeftTitle3= "养生元（元）"
                this.leftData3 = res.data.firstBalanceAmount||0;
                this.rightTitle3= "赠送金（元）"
                this.rightData3 = res.data.firstGiveAmount||0;

                this.title4="本月复充客户数量/金额（人/元）";
                this.data4 = res.data.repeatedNumberPeople+"/"+res.data.repeatedAmount;
                this.LeftTitle4= "养生元（元）"
                this.leftData4 =res.data.repeatedBalanceAmount||0;
                this.rightTitle4= "赠送金（元）"
                this.rightData4 =res.data.repeatedGiveAmount||0;

            }else{
                this.title1="累计储蓄金额（元）";
                this.data1 = res.data.chargeAmount
                this.LeftTitle1= "养生元（元）"
                this.leftData1=res.data.balanceAmount||0;
                this.rightTitle1= "赠送金（元）"
                this.rightData1=res.data.giveAmount||0;

                this.title2="累计储蓄笔（笔）";
                this.data2 = res.data.totalCount

                this.LeftTitle2= "首次（笔）"
                this.leftData2 = res.data.firstCount;
                this.rightTitle2= "复充（笔）"
                this.rightData2 = res.data.repeatedCount;



                this.title3="累计充值客户数量（人）";
                this.data3 = res.data.totalNumberPeople||0;

                this.LeftTitle3= "   "
                this.leftData3 = " ";
                this.rightTitle3= "   "
                this.rightData3 = "  "

                this.title4="待核销金额（元）";
                this.data4 = res.data.verificationAmount||0;
                this.LeftTitle4= "养生元（元）"
                this.leftData4 =res.data.verificationBalanceAmount||0;
                this.rightTitle4= "赠送金（元）"
                this.rightData4 =res.data.verificationGiveAmount||0;
            }

        });
    }
}
